import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';
import previewVideoNo from './assets/no_skrivhastighet_video.mov';
import previewVideoNn from './assets/nn_skrivhastighet_video.mov';

import dataNo from './languages/no-data.json';
import dataNn from './languages/nn-data.json';
import audioNo from 'assets/sounds/no/4 1 Skrivehastighet Intro.mp3';
import audioNn from 'assets/sounds/nn/4 1 Skrivehastighet Intro.wav';

import audioNoNorming from 'assets/sounds/no/4 1 Skrivehastighet Intro-norming.mp3';
import audioNnNorming from 'assets/sounds/nn/4 1 Skrivehastighet Intro.wav';
const dataObj = {
	no: {
		data: dataNo,
		audio: audioNo,
		audioNorming: audioNoNorming,
		video: previewVideoNo,
	},
	nn: {
		data: dataNn,
		audioNorming: audioNnNorming,
		audio: audioNn,
		video: previewVideoNn,
	},
};

class Intro extends React.Component {
	constructor(props) {
		super(props);

		const assets = dataObj[strings.getLanguage()];

		this.audio = this.props.isDldTest ? assets.audioNorming : assets.audio;
		this.skrivehastighetIntro = this.props.isDldTest
			? strings.skrivehastighetIntroNorming
			: strings.skrivehastighetIntro;

		this.skrivehastighetIntro2 = this.props.isDldTest
			? strings.skrivehastighetIntro2Norming
			: strings.skrivehastighetIntro2;

		this.text = assets.data[0].value;
		this.video = assets.video;
		this.videoRefView = React.createRef();
	}

	render() {
		const {onNextStep} = this.props;

		let videoRef;

		return (
			<div className="">
				<p
					className={
						this.props.isDldTest ? 'text-center' : 'text-left'
					}
				>
					<AudioPlayer
						autoplay
						inline
						onStart={() => {
							const scrollActionTime = 33200;

							if (scrollActionTime) {
								setTimeout(() => {
									if (this.videoRefView.current) {
										this.videoRefView.current.scrollIntoView(
											{
												behavior: 'smooth',
												block: 'start',
											}
										);
										videoRef.play();
									}
								}, scrollActionTime);
							}
						}}
						onPause={() => {
							videoRef.play();
						}}
						onErrorPlay={() => {
							console.log('Something went wrong');
						}}
						src={this.audio}
					/>
					{this.skrivehastighetIntro}
				</p>
				<br />
				<div className="tutorial-text">
					<h3 className="text">
						<strong>{this.text}</strong>
					</h3>
				</div>
				<p>{this.skrivehastighetIntro2}</p>

				<div className="lit-preview" ref={this.videoRefView}>
					<p className="lit-preview__label">
						{strings.testLooksLikeThis}
					</p>
					<video
						className="lit-preview__video"
						loop
						onClick={() => {
							videoRef.play();
						}}
						ref={(ref) => {
							videoRef = ref;
						}}
						src={this.video}
					/>
				</div>

				<p>{strings.skrivehastighetHint}</p>

				<button
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.start}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
